<template>
  <div class="page search-result-page">
    <div class="category-swiper">
      <swiper
          :modules="modules"
          slidesPerView="6"
          :spaceBetween="21"
          @swiper="onSwiper"
      >
        <swiper-slide class="category-card" v-for="(item, index) in categoryList" :key="index"
                      @click="clickCategoryCard(item)">
          <img class="abs" :src="item.image" alt="" style="z-index: 0;background: #c0c0c0;">
          <div v-if="queryParams.categoryId === item.id" class="mask abs" style="z-index: 1;background: #C01A1A"></div>
          <div class="abs" style="z-index: 2">{{ item.name }}</div>
        </swiper-slide>
      </swiper>

      <div class="vector left-position" @click="slide('prev')">
        <img src="@/assets/images/vector-left.png" alt="">
      </div>
      <div class="vector right-position" @click="slide('next')">
        <img src="@/assets/images/vector-right.png" alt="">
      </div>

      <div class="left-mask"></div>
      <div class="right-mask"></div>
    </div>

    <div class="search-module">
      <div class="search-box">
        <div class="search-icon"><img :src="require('@/assets/images/search.png')" alt="img"></div>
        <input
            type="text"
            class="search"
            placeholder="输入文物名称查找"
            autofocus
            v-model="queryParams.searchTerm"
            @keydown="keydown"
        />
      </div>
    </div>

    <div class="second-category">
      <custom-checkbox v-model="queryParams.parameterValues" :data="attributeArr" @update:modelValue="handleSelect" />
    </div>

    <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        style=""
        @load="getCulturalRelicList"
    >
      <cr-list :cr-list="dataList" v-if="dataList.length > 0" />
    </van-list>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getAttribute, getCategory, listCulturalRelic } from '@/apis'

import CustomCheckbox from './CustomCheckbox.vue'
import CrList from '@/components/CrList/index'
// import { Pagination, Autoplay, EffectFade } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import 'swiper/swiper.scss'
import 'swiper/modules/pagination/pagination.scss'

const modules = []

const route = useRoute()
const router = useRouter()

// 搜索条件汇总
const queryParams = ref({})

function resetQueryParams () {
  queryParams.value = {
    searchTerm: '',
    categoryId: '',
    parameterValues: [],
    page: 1,
    pageSize: 12
  }
}

resetQueryParams()

const {
  searchTerm,
  parameterValues
} = route.query
queryParams.value.searchTerm = searchTerm || ''
queryParams.value.parameterValues = parameterValues ? parameterValues.split(',') : []

let timer

function reload () {
  timer && clearTimeout(timer)
  loading.value = false
  finished.value = true
  queryParams.value.page = 1
  dataList.value = []

  timer = setTimeout(() => {
    loading.value = false
    finished.value = false
  }, 100)
}

// 轮播图部分
const categoryList = ref([])
getCategory().then(res => {
  categoryList.value = res.data
})

let swiperRef = null

function clickCategoryCard (category) {
  resetQueryParams()
  if (queryParams.value.categoryId !== category.id) {
    queryParams.value.categoryId = category.id
  } else {
    queryParams.value.categoryId = null
  }
  reload()
}

function onSwiper (swiper) {
  swiperRef = swiper
}

function slide (type) {
  if (type === 'next') {
    swiperRef.slideNext()
  } else {
    swiperRef.slidePrev()
  }
}

// 搜索框按下回车键搜索
function keydown (e) {
  if (e.code === 'Enter') {
    reload()
  }
}

// // 根据属性搜索
// const detailArr = ref({
//   id: '3d',
//   name: '3D模型'
// })
const attributeArr = ref([
  {
    id: '1',
    name: '元素',
    detailArr: [
      {
        id: '3d',
        name: '3D模型'
      }
    ]
  }
])
// getAttribute().then(res => {
//   attributeArr.value = res.data.map(item => ({
//     ...item,
//     detailArr: item.parameterDTOS
//   })
//   )
// })

function handleSelect (data) {
  reload()
}

// 搜索结果
const finished = ref(false)
const loading = ref(false)
const dataList = ref([])

function getCulturalRelicList () {
  listCulturalRelic({
    ...queryParams.value,
    parameterValues: queryParams.value.parameterValues.join(',')
  }).then(res => {
    const data = res.data?.map(item => {
      item = {
        ...item,
        properties: []
      }
      item.type && item.properties.push(item.type)
      item.period && item.properties.push(item.period)
      return item
    })
    if (!data || data.length <= 0) {
      finished.value = true
      return
    }

    dataList.value = dataList.value.concat(data)
    queryParams.value.page += 1
    loading.value = false

    if (data.length < queryParams.value.pageSize) {
      finished.value = true
    }
  })
}
</script>

<style lang="scss" scoped>
.search-result-page {
  padding-top: 90px;
}

.category-swiper {
  margin: 42px 123px;
  height: 70px;
  position: relative;

  .category-card {
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    color: white;
    letter-spacing: 2px;
    overflow: hidden;
    margin-right: 1.3125rem;
    cursor: pointer;
    position: relative;
    border-radius: 5px;

    .mask {
      z-index: 2;
      cursor: pointer;
    }
  }

  .right-position {
    right: -25px;
  }

  .left-position {
    left: -25px;
  }

  .vector {
    position: absolute;
    top: 50%;
    z-index: 10;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    border: 1px solid #eee;
    cursor: pointer;

    img {
      width: 27px;
      height: 13px;
    }
  }

  .left-mask, .right-mask {
    position: absolute;
    z-index: 9;
    top: 0;
    width: 340px;
    height: 100%;
    pointer-events: none
  }

  .left-mask {
    background: linear-gradient(to right, #FDFCFA, rgba(0, 0, 0, 0));
    left: 0;
  }

  .right-mask {
    background: linear-gradient(to left, #FDFCFA, rgba(0, 0, 0, 0));
    right: 0;
  }
}

.second-category,
.search-module {
  margin-top: 26px;
  margin-bottom: 48px;
  padding: 0 123px;
}

.search-module {
  .search-box {
    display: flex;
    align-items: center;
    padding: 0 48px;
    width: 100%;
    height: 75px;
    border: 3px solid #c4c4c4;
    border-radius: 5px;
    background-color: white;
    margin: 0 auto;
  }

  .search-icon {
    width: 34px;
    height: 34px;
    margin-right: 55px;
  }

  .search {
    flex: 1;
    background-color: white;
    font-size: 30px;
    font-weight: 300;
  }
}

.van-list {
  padding: 50px 86px 0;
  border-top: 1px solid #E5E5E5;
}
</style>
